import { SendOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setPdfConversation,
  setPdfConversationMessageRetry,
} from "../../../../../redux/actions/pdfAI";
import http from "../../../../../utils/http";
import { getIntl } from "../../../../../utils/intl";
import { AiChatTranslations } from "./translations";

function ChatInput({ aiChatId, ...props }) {
  const message = useRef(null);
  const dispatch = useDispatch();
  const intl = getIntl();
  const { company_id: companyId } = useSelector((state) => state.companyConfig);
  let conversation = useSelector((state) => state.pdfConversation.conversation);
  let retry = useSelector((state) => state.pdfConversation.retry);

  const linkId = aiChatId; // Change

  const CHAT_AI_URL = `/company/${companyId}/link/${linkId}/ai/support/chat`;

  /**
   *
   * Checks if previous message had an error, if yes, block conversation update.
   */
  const updateGlobalConversation = (currentMessage, role) => {
    if (conversation.length === 0) {
      conversation = [...conversation, { content: currentMessage, role }];
      dispatch(setPdfConversation(conversation));
      message.current.value = "";
    } else {
      if (!conversation[conversation.length - 1].error) {
        conversation = [...conversation, { content: currentMessage, role }];
        dispatch(setPdfConversation(conversation));
        message.current.value = "";
      }
    }
  };

  const sendMessage = async (_message, isRetry = false) => {
    const currentMessage = _message || message.current.value;
    if (!isRetry) {
      updateGlobalConversation(currentMessage, "user");
    }

    try {
      let response;
      if (!isRetry) {
        response = await http.post(CHAT_AI_URL, {
          conversation,
          next_question: currentMessage,
        });
      } else {
        const previousConversation = conversation;
        previousConversation[previousConversation.length - 1].error = false;
        response = await http.post(CHAT_AI_URL, {
          conversation: previousConversation,
          next_question: currentMessage,
        });
        dispatch(setPdfConversation([...previousConversation]));
      }
      const serverMessage = response.data.payload.latest_answer;
      updateGlobalConversation(serverMessage, "assistant");
    } catch (error) {
      console.log(conversation, conversation.length);
      conversation[conversation.length - 1].error = true;
      dispatch(setPdfConversation([...conversation]));
    }
  };

  /**
   * Retry previously failed message
   */
  const retryFailedMessage = () => {
    const { message } = conversation[conversation.length - 1];
    // Failed messages are always from the user, never from the assistant.
    sendMessage(message, true);
  };

  useEffect(() => {
    if (retry) retryFailedMessage();
    dispatch(setPdfConversationMessageRetry(false));
  }, [retry]);

  return (
    <div>
      <Row gutter={6}>
        <Col xs={20} lg={22}>
          <textarea
            ref={message}
            placeholder={intl.formatMessage(
              AiChatTranslations.messagePlaceholder
            )}
          ></textarea>
        </Col>
        <Col xs={4} lg={2}>
          <div className="button__wrapper">
            <div className="button__wrapper--v-center">
              <Button
                onClick={() => sendMessage()}
                type="primary"
                shape="circle"
                size="large"
                icon={<SendOutlined />}
              ></Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ChatInput;
